<div class="grid-container grid-container--fill">
  <div class="grid-element" *ngFor="let x of equip" style="text-align: center;">
    <img src="assets/Equipments/{{ x }}.jpg" style="width: 100%;" />{{ x }}
  </div>
</div>
